import React from 'react';
import { connect } from 'react-redux';
import {
  pageRequest,
  shiftDetailsRequest,
  hideShiftDetail,
  shiftSummaryLoadMoreData,
} from 'actions/reports/shifts';
import { currencyFormatter } from 'utils/formatter';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import InfiniteScroll from 'react-infinite-scroller';
import NoDataAndLoading from 'components/NoDataAndLoading';
import ActionBar from './ActionBar';
import styles from './shift.css';
import ShiftDetailModal from './ShiftDetail/ShiftDetailModal';
import ShiftDetail from './ShiftDetail';
import { getFormattedTime } from '../../../utils/hourFilter';

class Shift extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shiftDetailOpened: false,
      isMobile: false,
      showModal: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(pageRequest());
  }

  renderShiftTable() {
    const {
      reports,
      currentOutlet,
      loadingSpinner: { showLoadingSpinnerPage },
    } = this.props.data;
    const { shifts, shiftDetails } = reports.shifts;

    return (
      <div
        className={`${styles.wrapper} ${
          showLoadingSpinnerPage ? styles['hide-table'] : ''
        }`}
      >
        <table
          id="shift-table"
          className={`moka-table table-truncate table-responsive mk-table-fixed mk-table-clickable table ${
            !shifts.length ? 'no-data' : styles['shift-left-table']
          }`}
        >
          <thead className={styles['thead-shift-table']}>
            <tr className="shift-row">
              <th className="text-center">Name</th>
              <th className="visible-md visible-lg text-center">Start Time</th>
              <th className="end-time text-center">End Time</th>
              {currentOutlet.length > 1 && (
                <th className="visible-md visible-lg text-center">Access</th>
              )}
              <th className="visible-md visible-lg text-center">
                Total Expected
              </th>
              <th className="visible-md visible-lg text-center">
                Total Actual
              </th>
              <th className="visible-md visible-lg text-center">Difference</th>
            </tr>
          </thead>
        </table>
        <div
          className={`${
            styles['table-content-wrapper']
          } shift-table-content-wrapper`}
        >
          <InfiniteScroll
            pageStart={1}
            loadMore={this._onReachBottom}
            hasMore={this._hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}
          >
            <table
              id="shift-table"
              className={`moka-table table-truncate table-responsive mk-table-fixed mk-table-clickable table ${
                !shifts.length ? 'no-data' : styles['shift-left-table-max']
              }`}
            >
              <tbody className={styles['tbody-shift-table']}>
                {shifts.map(shift => {
                  const klassNames = [];
                  if (shiftDetails && shiftDetails.id === shift.id)
                    klassNames.push('selected');
                  return (
                    <tr
                      key={shift.id}
                      onClick={() => this._onClickShiftRow(shift)}
                      className={`shift-row ${klassNames.join(' ')}`}
                    >
                      <td className="text-center">{shift.employee_name}</td>
                      <td className="visible-md visible-lg text-center">
                        {moment
                          .parseZone(shift.created_at)
                          .format('D/MM/YYYY HH:mm')}
                      </td>
                      <td className="end-time text-center">
                        {shift.ended_at === null
                          ? '-'
                          : moment
                              .parseZone(shift.ended_at)
                              .format('D/MM/YYYY HH:mm')}
                      </td>

                      {currentOutlet.length > 1 && (
                        <td className="visible-md visible-lg text-center">
                          {shift.outlet_name}
                        </td>
                      )}
                      <td className="visible-md visible-lg text-center">
                        {shift.ended_at === null
                          ? '-'
                          : currencyFormatter(shift.total_expected)}
                      </td>
                      <td className="visible-md visible-lg text-center">
                        {shift.ended_at === null
                          ? '-'
                          : currencyFormatter(shift.total_actual)}
                      </td>
                      <td className="visible-md visible-lg text-center">
                        {shift.ended_at === null
                          ? '-'
                          : currencyFormatter(shift.total_difference)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>
    );
  }

  render() {
    const { reports, loadingSpinner } = this.props.data;
    const { shifts, shiftDetails, paymentMethodCategories } = reports.shifts;

    return (
      <div
        className={`container-full-nosub ${styles['shift-report']}`}
        id="shifts"
      >
        <div className="container no-padding shift-container">
          <div className="mk-action-bar">
            <ActionBar isMobile={this.state.isMobile} />
          </div>
          <div className={styles['shift-table']}>
            <div className={styles['mk-report-transaction']}>
              <div className={styles['row-shift']}>
                <div
                  className={`col-sm-12 col-md-12 trans-1 box-customers no-padding ${
                    styles['box-table']
                  }`}
                  id="mk-col-left"
                >
                  <div className={styles['transaction-table']}>
                    <NoDataAndLoading
                      showLoadingSpinner={loadingSpinner.showLoadingSpinnerPage}
                      noDataToDisplay={shifts.length === 0}
                      title="No Data To Display"
                      description="You can start shift through your device, or select different time frame."
                      linkLabel="Start Shift"
                      linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000454726-Cara-Memulai-Shift"
                    />
                    {shifts.length > 0 && this.renderShiftTable()}
                  </div>
                </div>
                {shiftDetails !== null && this.state.isMobile && (
                  <ShiftDetailModal
                    onClickDoneButton={this._onClickShiftDetailDoneButton}
                    shift={shiftDetails}
                    paymentMethodCategories={paymentMethodCategories}
                    show={this.state.showModal}
                    onHide={this._closeModal}
                  />
                )}

                {shiftDetails !== null &&
                  this.state.shiftDetailOpened &&
                  !this.state.isMobile && (
                    <ShiftDetail
                      onClickDoneButton={this._onClickShiftDetailDoneButton}
                      shift={shiftDetails}
                      paymentMethodCategories={paymentMethodCategories}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _closeModal = () => {
    const isMobile =
      document.getElementsByClassName('visible-md')[0].offsetParent == null;
    this.setState({
      shiftDetailOpened: false,
      isMobile,
      showModal: false,
    });
    this.props.dispatch(hideShiftDetail(isMobile));
  };

  _onClickShiftRow = shift => {
    const isMobile =
      document.getElementsByClassName('visible-md')[0].offsetParent == null;
    this.setState({
      shiftDetailOpened: !isMobile,
      isMobile,
      showModal: isMobile,
    });
    this.props.dispatch(shiftDetailsRequest(shift.id, isMobile));
  };

  _onClickShiftDetailDoneButton = () => {
    const isMobile =
      document.getElementsByClassName('visible-md')[0].offsetParent == null;
    this.setState({
      shiftDetailOpened: false,
      isMobile,
      showModal: false,
    });
    this.props.dispatch(hideShiftDetail(isMobile));
  };

  _onReachBottom = () => {
    const {
      dispatch,
      data: { reports },
      search: {
        date: { startDate, endDate, startHour, endHour, allDay },
      },
    } = this.props;
    const { shifts, page } = reports.shifts;
    const currentPage = page === 0 ? page + 1 : page;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    dispatch(
      shiftSummaryLoadMoreData(
        {
          page: currentPage + 1,
          startDate: formattedStart,
          endDate: formattedEnd,
        },
        shifts
      )
    );
  };

  _hasMore = () => {
    const {
      data: { reports },
    } = this.props;
    const { shiftSummary, page } = reports.shifts;
    const totalPage = shiftSummary.total_pages;
    return page < totalPage;
  };
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  // only fetch some state
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    data: {
      reports: state.reports,
      currentOutlet: state.outlet.currentOutlet,
      loadingSpinner: state.loadingSpinner,
    },
  };
}

export default connect(mapStateToProps)(Shift);
